import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_cover_promotion_image_size.js";
import "./menu_cover_promotion_type.js";
import "./vitrine_cover_block_type.js";
//#region src/menu_cover_promotion_type_helper.ts
var menu_cover_promotion_type_helper_exports = /* @__PURE__ */ __exportAll({
	isFullWidth: () => isFullWidth,
	isHalfWidth: () => isHalfWidth,
	isValidMedium: () => isValidMedium,
	isValidRegular: () => isValidRegular,
	isValidSmall: () => isValidSmall,
	isVitrineImageSize: () => isVitrineImageSize,
	mediumVitrineTypes: () => mediumVitrineTypes,
	name: () => name,
	regularVitrineTypes: () => regularVitrineTypes,
	requiredMinimumCount: () => requiredMinimumCount,
	smallVitrineTypes: () => smallVitrineTypes,
	validPromotionImageSizeForPromotionType: () => validPromotionImageSizeForPromotionType,
	vitrineBlockData: () => vitrineBlockData,
	vitrineImageSizes: () => vitrineImageSizes,
	vitrineTypes: () => vitrineTypes
});
const smallVitrineTypes = [
	"carousel-s",
	"single-s",
	"grid-s"
];
const mediumVitrineTypes = [
	"carousel-m",
	"single-m",
	"grid-m"
];
const regularVitrineTypes = [
	"carousel-r",
	"single-r",
	"grid-r"
];
const vitrineTypes = [
	...smallVitrineTypes,
	...mediumVitrineTypes,
	...regularVitrineTypes
];
const vitrineImageSizes = [
	"vitrine-sm-full-width",
	"vitrine-sm-half-width",
	"vitrine-md-full-width",
	"vitrine-md-half-width",
	"vitrine-rg-full-width",
	"vitrine-rg-half-width"
];
const vitrineBlockData = {
	["promo_small"]: {
		label: "Small",
		imageSizes: ["vitrine-sm-full-width", "vitrine-sm-half-width"]
	},
	["promo_medium"]: {
		label: "Medium",
		imageSizes: ["vitrine-md-full-width", "vitrine-md-half-width"]
	},
	["promo_regular"]: {
		label: "Regular",
		imageSizes: ["vitrine-rg-full-width", "vitrine-rg-half-width"]
	}
};
function isVitrineImageSize(imageSize) {
	return vitrineImageSizes.some((vitrineImageSize) => vitrineImageSize === imageSize);
}
function name(promotionType) {
	switch (promotionType) {
		case "carousel-s": return "Carousel (Small)";
		case "carousel-m": return "Carousel (Medium)";
		case "carousel-r": return "Carousel (Regular)";
		case "grid-s": return "Grid (Small)";
		case "grid-m": return "Grid (Medium)";
		case "grid-r": return "Grid (Regular)";
		case "single-s": return "Single (Small)";
		case "single-m": return "Single (Medium)";
		case "single-r": return "Single (Regular)";
		case "gcn": return "GCN";
	}
}
function requiredMinimumCount(promotionType) {
	switch (promotionType) {
		case "carousel-s":
		case "carousel-m":
		case "carousel-r": return 3;
		case "grid-s":
		case "grid-m":
		case "grid-r": return 2;
		case "single-s":
		case "single-m":
		case "single-r": return 1;
	}
}
function isValidMedium(promotionType) {
	return mediumVitrineTypes.some((mediumType) => mediumType === promotionType);
}
function isValidSmall(promotionType) {
	return smallVitrineTypes.some((smallType) => smallType === promotionType);
}
function isValidRegular(promotionType) {
	return regularVitrineTypes.some((regularType) => regularType === promotionType);
}
function isFullWidth(promotionType) {
	return promotionType === "carousel-s" || promotionType === "carousel-m" || promotionType === "carousel-r" || promotionType === "single-s" || promotionType === "single-m" || promotionType === "single-r";
}
function isHalfWidth(promotionType) {
	return promotionType === "grid-s" || promotionType === "grid-m" || promotionType === "grid-r";
}
function validPromotionImageSizeForPromotionType(promotionType) {
	switch (promotionType) {
		case "grid-s": return "vitrine-sm-half-width";
		case "grid-m": return "vitrine-md-half-width";
		case "grid-r": return "vitrine-rg-half-width";
		case "carousel-s":
		case "single-s": return "vitrine-sm-full-width";
		case "carousel-m":
		case "single-m": return "vitrine-md-full-width";
		case "carousel-r":
		case "single-r": return "vitrine-rg-full-width";
	}
}
//#endregion
export { isFullWidth, isHalfWidth, isValidMedium, isValidRegular, isValidSmall, isVitrineImageSize, mediumVitrineTypes, menu_cover_promotion_type_helper_exports, name, regularVitrineTypes, requiredMinimumCount, smallVitrineTypes, validPromotionImageSizeForPromotionType, vitrineBlockData, vitrineImageSizes, vitrineTypes };

//# sourceMappingURL=menu_cover_promotion_type_helper.js.map